import { Component, OnDestroy, OnInit } from '@angular/core';

import { AuthService } from '../../services/core/auth.service';
import { AppNotificationService } from '../../services/app/notification.service';

import { APP_BASE_URL, CONSTRAINTS } from '../constants';

import { Subscription, timer } from 'rxjs';

interface Notification {
  label: string;
  routerLink: string;
  queryParams?: object;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  public readonly APP_BASE_URL = APP_BASE_URL;
  public refUserIsStaff: boolean = false;

  public notifications: Notification[] = [];

  private subscription: Subscription = null;

  constructor(private readonly auth: AuthService, private readonly notificationService: AppNotificationService) {}

  ngOnInit() {
    this.refUserIsStaff = this.auth.getUser().staffFlag;
    this.notificationService.notificationSubject.subscribe((payload) => {
      this.notifications = payload || [];
    });

    this.subscription = timer(0, CONSTRAINTS.RXJS_TIMER_INTERNAL.ONE_MINUTE).subscribe(() => {
      this.notificationService.getNotifications();
    });
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
